import React, { createRef, PureComponent, RefObject, ReactNode } from 'react';
import cn from 'classnames';
import { EmptyObject } from '../shared.interfaces';
import Fieldset from './fieldset';
import './style.scss';
import { Option } from './types';

type Info = Option;

type WithValidation = (action: () => void) => () => void | null;

type WithoutValidation = (action: () => void) => () => void;

export type CcInfoType<T> = T & {
  members: Array<Info>;
};

export type CcDataType<K> = K;

interface IProps<T, K> {
  name: string;
  info: CcInfoType<T> | EmptyObject;
  data: CcDataType<K> | EmptyObject;
  after?: (withValidation: WithValidation, withoutValidation: WithoutValidation) => ReactNode;
  changeHandler?: (data: CcDataType<K> | EmptyObject) => void;
  disabledForm: boolean;
  hasAccessToGetUnmasked?: boolean;
}

interface IState {
  displayErrors: boolean;
}

class Form<T, K> extends PureComponent<IProps<T, K>, IState> {
  state = {
    displayErrors: false,
  };

  formRef: RefObject<HTMLFormElement> = createRef();

  validate = () => {
    const valid = this.formRef.current?.checkValidity();

    this.setState({ displayErrors: true });
    return valid;
  };

  resetValidation = () => {
    this.setState({ displayErrors: false });
  };

  returnActionWithValidation = (action: () => void) => () => {
    if (this.validate()) {
      return action();
    }

    return null;
  };

  returnActionWithNoValidation = (action: () => void) => () => {
    this.resetValidation();
    return action();
  };

  render(): JSX.Element {
    const { name, info, data, after, changeHandler, disabledForm, hasAccessToGetUnmasked } = this.props;
    const { displayErrors } = this.state;

    return (
      <div>
        {info && (
          <form ref={this.formRef} className={cn('cc-form', { 'cc-from--validation': displayErrors })}>
            <Fieldset<K>
              name={name}
              members={info.members}
              data={data}
              changeForm={changeHandler}
              getter={[]}
              defaultExpanded
              disabledForm={disabledForm}
              hasAccessToGetUnmasked={hasAccessToGetUnmasked}
            />
            <div className="cc-footer">
              {after && after(this.returnActionWithValidation, this.returnActionWithNoValidation)}
            </div>
          </form>
        )}
      </div>
    );
  }
}

export default Form;
